export default (document.location.host.indexOf('stg')!==-1?
    process.env.VUE_APP_GOOGLE_KEY.replace('//','//stg.'):
    process.env.VUE_APP_GOOGLE_KEY
)
